/** The route key header */ export const RouteKeyHeader = "X-Project-SessionCluster";
/** The project session token header */ export const ProjectSessionTokenHeader = "x-project-sessionToken";
/** The revision token header */ export const RevisionTokenHeader = "Revisiontoken";
/** The viewport id header */ export const ViewportIdHeader = "viewPortId";
/** The viewport definition header */ export const ViewportDefinitionHeader = "viewportDefinition";
/** Constant for the key to the selfServiceSession value for the self-serve flow */ export const SelfServiceSession = "x-project-selfServiceSession";
/** Constant for strong consistency token*/ export const Allotments = "Allotments";
